import React, { Component } from "react";
import {
    Col,
    Row,
    Input,
    Button,
    Label
} from "reactstrap";

import Registry from "../../../Utils/Registry";
import Helpers from "../../../Utils/Helpers";
import {NotificationManager} from "react-notifications";
import Vars from "../../../Utils/Variables";


class EnterpriseCoworkersBaseForm extends Component{
    constructor(props){
        super(props);

        this.handleInputUpdate = this.handleInputUpdate.bind(this);
        this.inviteCustomer = this.inviteCustomer.bind(this);

        this.api = Registry.registered("api");

        this.state = {
            loading: false,
            first_name: "",
            last_name: "",
            email: "",
			account_type: 0,
            field_errors: {
                first_name: false,
                last_name: false,
                email: false,
				account_type: false
            }
        };
    }

    handleInputUpdate(e, key){
        let s = this.state;
        if(s.hasOwnProperty(key))
            s[key] = e.target.value;
        this.setState(s);
    }

    inviteCustomer(){
        let errors = Helpers.checkFieldErrors([
            "first_name",
            "last_name",
            "email"
        ], this.state);
        this.setState({field_errors: errors.fields});

        if(errors.pass){
            this.setState({loading: true});

            this.api.post("/business/coworkers/invite", {
                email: this.state.email,
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                account_type: this.state.account_type
            })
            .then(results => {
                this.setState({
                    loading: false,
                    first_name: "",
                    last_name: "",
                    email: "",
                    account_type: 0
                }, () => {
                    NotificationManager.success("Une invitation a été envoyée à l'email fourni")
                });
                this.props.onCustomerInvited(results.customer);
            })
            .catch(error => {
                let message = "";
                if(error.hasOwnProperty("subcode")){
                    switch(error.subcode){
                        case "POSTBusinessEmailExists":
                            message = "Un utilisateur avec cet email existe déjà.";
                            break;
                        default:
                            message = "Impossible d'inviter le collaborateur.";
                            break;
                    }
                }
                this.setState({loading: false}, () => {
                    if (message !== "")
                        NotificationManager.error(message);
                });
            });
        }
    }

    render(){
        return (
            <div>
                <div>
                    <Row className="marg-b-10">
                        <Col md="6">
                            <Label className="bold">Pr&eacute;nom</Label>
                            <Input
                                type="text"
                                className={"wp-100" + (this.state.field_errors.first_name ? " error" : "")}
                                value={this.state.first_name}
                                onChange={e => {this.handleInputUpdate(e, "first_name")}}
                                required
                            />
                        </Col>
                        <Col md="6">
                            <Label  className="bold">Nom</Label>
                            <Input
                                className={"wp-100" + (this.state.field_errors.last_name ? " error" : "")}
                                value={this.state.last_name}
                                onChange={e => {this.handleInputUpdate(e, "last_name")}}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="marg-b-10">
                        <Col md="12">
                            <Label className="bold">
                                Email
                                <span className="font-xs gray marg-l-10">(Une invitation sera envoy&eacute;e &agrave; cet email)</span>
                            </Label>
                            <Input
                                type="text"
                                value={this.state.email}
                                onChange={e => {this.handleInputUpdate(e, "email")}}
                                className={"wp-100" + (this.state.field_errors.email ? " error" : "")}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="marg-b-10">
                        <Col md="12">
                            <Label className="bold">
                                Type de compte
                                <span className="font-xs gray marg-l-10">(Notifications mail)</span>
                            </Label>
							<select className={"form-control"} onChange={e => {this.handleInputUpdate(e, "account_type")}}>
								{Vars.business_customer_notifications_types.map((opt, i) => {
									return <option key={"opt-grp-"+i} value={opt.value}>
										{opt.title}
									</option>
								})}
							</select>
                        </Col>
                    </Row>
                </div>
                <div className="center marg-t-20">
                    <Button color="primary" className="text-uppercase" onClick={this.inviteCustomer}>
                        {
                            this.state.loading ?
                                <i className="icon icon-loading animated spin infinite f-18"> </i>
                                :
                                "Ajouter"
                        }
                    </Button>
                </div>
            </div>
        );
    }
}

EnterpriseCoworkersBaseForm.defaultProps = {
    onCustomerInvited: customer => {}
};

export default EnterpriseCoworkersBaseForm;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Coworkers/BaseForm.js